import { useEffect } from "react";
import "./App.css";
import AppRoutes from "./Components/AppRoutes";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "../src/css/general.css";
import "../src/css/appColors.css";
import { AppContextProvider } from "./Context/AppContext";

function App() {
  return (
    <AppContextProvider>
      <AppRoutes />
    </AppContextProvider>
  );
}

export default App;
